import classNames from 'classnames';
import { FC } from 'react';

import { IcMicOff16Icon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './MutedBadge.styles.m.css';

interface IMutedBadgeProps {
  className?: string;
}

export const MutedBadge: FC<IMutedBadgeProps> = ({ className }) => {
  return (
    <div className={classNames(styles.iconContainer, className)}>
      <IconView
        Icon={IcMicOff16Icon}
        size={IconViewSizes.Small}
        className={styles.icon}
      />
    </div>
  );
};
